import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const rolloutsApi = createApi({
    reducerPath: "rolloutsApi",
    tagTypes: ["OtaFiles", "Rollouts"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        getOtaFiles: rtkClient.getOtaFiles(builder),
        saveOtaAnnotation: rtkClient.saveOtaAnnotation(builder),
        deleteOtaAnnotation: rtkClient.deleteOtaAnnotation(builder),
        createRollout: rtkClient.createRollout(builder),
        getRolloutsByBuild: rtkClient.getRolloutsByBuild(builder),
        getRolloutById: rtkClient.getRolloutById(builder),
        deleteRollout: rtkClient.deleteRollout(builder),
        updateRollout: rtkClient.updateRollout(builder),
    }),
});

export const {
    useGetOtaFilesQuery,
    useSaveOtaAnnotationMutation,
    useDeleteOtaAnnotationMutation,
    useCreateRolloutMutation,
    useGetRolloutsByBuildQuery,
    useGetRolloutByIdQuery,
    useUpdateRolloutMutation,
    useDeleteRolloutMutation,
} = rolloutsApi;
